var map = {
	"./black/xiazailuyin2.png": "TX9/",
	"./blue/xiazailuyin2.png": "87HU",
	"./white/xiazailuyin2.png": "318J"
};
function webpackContext(req) {
	return __webpack_require__(webpackContextResolve(req));
};
function webpackContextResolve(req) {
	var id = map[req];
	if(!(id + 1)) // check for number or string
		throw new Error("Cannot find module '" + req + "'.");
	return id;
};
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "wCd2";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/bottom ^\.\/.*\/xiazailuyin2\.png$
// module id = wCd2
// module chunks = 24